module.exports = __webpack_public_path__ + "static/icon_cerca_milano-f865a21e2d6b80f4c32cc5e70fa351f0.svg";